import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Row, theme, Select, Col } from 'antd'

// slices
import { sprintsState } from '../sprints/sprints.slice'
import { loginState } from '../login/login.slice'
import {
    clearFilterDropDown,
    tasksState,
    filterDropdown,
    taskList,
    searchTasks,
} from './tasks.slice'

// styles
import Button from '../../components/button/button'
import { projectsState } from '../projects/projects.slice'

const TasksFilter = ({ props }) => {
    const { clearSearch, typeFilter, setTypeFilter, setExportSprintId, selectedTeamMembers, setSelectedTeamMembers } = props

    const { useToken } = theme

    const { token } = useToken()

    const { pageLimit, skipPage, dropDownValue, search } = useSelector(tasksState)

    const { sprints } = useSelector(sprintsState)
    const { userProfile } = useSelector(loginState)
    const { currentProjectData } = useSelector(projectsState)

    const [taskTypeOption, setTaskTypeOption] = useState([])
    const { Option } = Select
    const dispatch = useDispatch()

    const [sprintsOption, setSprintsOption] = useState([])

    const initialValues = useMemo(() => {
        return {
            sprintId:
                localStorage.getItem('currentSprint') &&
                JSON.parse(localStorage.getItem('currentSprint'))?.id,
            assignee: [],
        }
    }, [])

    const [values, setValues] = useState({})

    useEffect(() => {
        setValues(initialValues)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const backlogId = sprints
            .filter((data) => data?.title === 'Backlog')
            .map((data) => data)
        localStorage.setItem(
            'currentSprint',
            JSON.stringify({
                id: backlogId[0]?._id,
                name: backlogId[0]?.title,
            })
        )

        initialValues['sprintId'] = backlogId[0]?._id
        setExportSprintId(backlogId[0]?._id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sprints, sprints.length])

    // SET SPRINT OPTIONS DEFAULT
    useEffect(() => {
        if (sprints?.length > 0) {
            const options = sprints
                .filter((data) => !data?.isComplete)
                .map((data) => {
                    return {
                        label: data?.title,
                        value: data?._id,
                    }
                })
            setSprintsOption([...options])
        }
    }, [sprints])

    // APPLY FILTER
    function applyFilter(name, value) {
        if (name == 'sprintId') {
            setExportSprintId(value)
        }
        setValues({
            ...values,
            [name]: value,
        })
        let newFilterValue = {}

        Object.keys(values).forEach((data) => {
            if (values[data] !== '' || values[data]?.length !== 0) {
                newFilterValue = { ...newFilterValue, [name]: value }
                dispatch(filterDropdown({ [name]: value }))
            } else {
                newFilterValue = { ...newFilterValue }
                dispatch(filterDropdown({}))
            }
        })

        dispatch(
            taskList({
                limit: pageLimit,
                skip: skipPage,
                search: search,
                filter: {
                    ...newFilterValue,
                    assignee: selectedTeamMembers,
                    projectId: userProfile?.activeProject?._id,

                },
            })
        )
        // const backlogId = sprints
        //     .filter((data) => data?.title === 'Backlog')
        //     .map((data) => data)
        // localStorage.setItem(
        //     'currentSprint',
        //     JSON.stringify({
        //         id: backlogId[0]?._id,
        //         name: backlogId[0]?.title,
        //     })
        // )

        const backlogId = sprints
            .filter((data) => data?._id === value)
            .map((data) => data)
        localStorage.setItem(
            'currentSprint',
            JSON.stringify({
                id: backlogId[0]?._id,
                name: backlogId[0]?.title,
            })
        )
    }

    const taskFilterType = (value, sprintId) => {

        dispatch(

            taskList({
                limit: pageLimit,
                skip: skipPage,
                filter: {
                    taskType: value,
                    projectId: userProfile?.activeProject?._id,
                    sprintId: sprintId

                },
            })
        )
    }



    function clearFilter() {
        setValues(initialValues)
        setSelectedTeamMembers([])
        clearSearch()
        setTypeFilter(null)
        dispatch(searchTasks(''))
        dispatch(clearFilterDropDown())
        const backlogId = sprints
            .filter((data) => data?.title === 'Backlog')
            .map((data) => data)
        localStorage.setItem(
            'currentSprint',
            JSON.stringify({
                id: backlogId[0]?._id,
                name: backlogId[0]?.title,
            })
        )
        dispatch(filterDropdown({ sprintId: backlogId[0]?._id }))

        dispatch(
            taskList({
                skip: skipPage,
                limit: pageLimit,
                filter: {
                    projectId: userProfile?.activeProject?._id,
                    sprintId: backlogId[0]?._id,
                },
            })
        )
    }

    // GET SWIMLANES
    useEffect(() => {

        if (currentProjectData?.taskType?.length > 0) {
            const options = currentProjectData?.taskType.map((data) => {
                return {
                    label: data,
                    value: data,
                }
            })
            setTaskTypeOption(options)
        }
    }, [currentProjectData])

    return (
        <Row align={'middle'} style={{ flexDirection: "row" }} gutter={[15, 15]}>
            {/* <Col span={10}>
                <Select
                    placeholder="Type"

                    className={['arrowStatusSelect']}
                    value={typeFilter}
                    onChange={(value) => {
                        setTypeFilter(value)
                        taskFilterType(value, values.sprintId)
                        // applyFilter('taskType', value)
                    }}
                    style={{
                        width: '100%',
                    }}
                // options={taskTypeOption?.name}
                > {taskTypeOption?.length > 0 &&
                    taskTypeOption.map((data) => (
                        <Option
                            value={data?.value}
                            key={data?.label}
                        >
                            {data?.label}
                        </Option>
                    ))}
                </Select>
            </Col> */}
            <Col span={15}>
                <Select
                    placeholder="Sprints"
                    defaultValue={
                        initialValues?.sprintId &&
                        sprintsOption?.length > 0 &&
                        initialValues?.sprintId
                    }
                    className={['arrowStatusSelect']}
                    value={values?.sprintId}
                    onChange={(value) => {
                        applyFilter('sprintId', value);
                        setTypeFilter(null)
                    }}
                    style={{
                        width: '100%',
                    }}
                    options={sprintsOption}
                />
            </Col>
            <Col span={4}>
                <Button
                    props={{
                        text: 'Clear Filter',
                        onClick: () => clearFilter(),
                        buttonType: 'link',
                        style: {
                            padding: '0px',
                            color: token.colorPalette.baseColor.black,
                        },
                    }}
                />
            </Col>
        </Row>
    )
}

export default TasksFilter
